<div class="list-group">
  <span class="d-flex justify-content-between list-group-item" (click)="darkModeService.updateDarkMode()">
        <span>Dark Mode 🌙</span>
        <span class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" [checked]="darkModeService.isDarkModeOn()">
        </span>
</span>
</div>
<h4 class="mb-0 text-center">Core Functions</h4>
<div class="list-group" *ngFor="let f of coreFunctions">
  <button class="list-group-item"
          [ngClass]="this.route === '/' + f.path ? 'disabled' : 'list-group-item-action'"
          [routerLink]="'/' + f.path"><i class="fa fa-sm {{f.icon}}"></i> {{f.name}}</button>
</div>
<h4 class="mb-0 text-center">Other Functions</h4>
<div class="list-group" *ngFor="let f of otherFunctions">
  <button class="list-group-item"
          [ngClass]="this.route === '/' + f.path ? 'disabled' : 'list-group-item-action'"
          [routerLink]="'/' + f.path"><i class="fa fa-sm {{f.icon}}"></i> {{f.name}}</button>
</div>

<h4 class="mb-0 text-center mt-3">Links</h4>
<div class="list-group" *ngFor="let f of links">
  <button class="list-group-item list-group-item-action"
          [ngClass]="this.route === '/' + f.path ? 'disabled' : 'list-group-item-action'"
          [routerLink]="'/' + f.path"><i class="fa fa-sm {{f.icon}}"></i> {{f.name}}</button>
</div>
